var _style, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#434343;}\n\t")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 100,
    cy: 100,
    r: 100
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.1,158.2c-1.2,0-2.4-0.4-3.2-1.3c-1.7-1.7-1.7-4.6,0-6.4l50.7-50.5L69.9,49.5c-1.7-1.7-1.7-4.6,0-6.4 s4.6-1.7,6.4,0l53.8,53.7c0.8,0.8,1.3,2,1.3,3.2s-0.5,2.4-1.3,3.2l-53.8,53.7C75.4,157.8,74.3,158.2,73.1,158.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRight);
export default __webpack_public_path__ + "static/media/icon-arrow-right.59e9104765b2ec156f943e194a67e733.svg";
export { ForwardRef as ReactComponent };